export default "__VITE_ASSET__DqD16onZ__"